var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.maintenanceMode)?_c('div',{staticClass:"maintenance-banner"},[_vm._v("\n    ⚠️ "),_c('strong',[_vm._v("Warning:")]),_vm._v(" The API is currently under maintenance. Some features may not work properly. ⚠️\n  ")]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }